import React from 'react';
import moment from 'moment-timezone';
import { Modal } from 'antd';

const LocalStorageKey = 'CONVIVA_PULSE_ANNOUNCEMENT_MODAL';

const checkTimingAvailable = () => {
  const now = moment();
  const end = moment('2023-11-23').endOf('day');

  return now.isBefore(end);
};

const PulseAnnouncementModal = () => {
  const [open, setOpen] = React.useState(true);

  if (!checkTimingAvailable() || localStorage.getItem(LocalStorageKey)) {
    return null;
  }

  // Update local storage to hide modal
  localStorage.setItem(LocalStorageKey, '1');

  return (
    <Modal
      open={open}
      closable={true}
      width={600}
      title={null}
      footer={null}
      onCancel={() => setOpen(false)}
    >
      <div>
        <p>
          <h3>Hello!</h3>
          <p>
            We&apos;re exploring the idea of an inaugural Conviva User
            Conference in 2024 - and we need your input! As an active Pulse
            user, your insight is critical.
          </p>
          <p>
            Fill out our quick survey to help us shape the topics, agenda, and
            structure for the event, so that it will be most valuable to you.
          </p>
          <div>
            <a
              href="https://www.conviva.com/conviva-user-conference"
              rel="noreferrer"
              target="_blank"
            >
              Conviva User Conference Interest Survey
            </a>
          </div>
        </p>
      </div>
    </Modal>
  );
};

export default PulseAnnouncementModal;
